export default "__VITE_ASSET__CsqIL9Lo__"